// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "96eb406693ed5bcfbed6fae04cf36210d97780ee/static/css/" + chunkId + "." + {"831":"583e16c7","854":"36854e5e","997":"755557fe"}[chunkId] + ".chunk.css";
};